// extracted by mini-css-extract-plugin
export default {"text_anchor":"TextAnchor_text_anchor__AdHT7","spin":"TextAnchor_spin__mKdNg"};